import React from 'react';

const GlassCard = ({ children, style, padding = 16, radius = 20, onClick, className = '' }) => (
  <div onClick={onClick} className={className} style={{
    background: 'rgba(255,255,255,0.06)',
    backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: radius, padding,
    transition: 'all 0.2s ease',
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  }}>
    {children}
  </div>
);

export default GlassCard;
